import { Link } from 'react-router-dom';
import { IconTooMeWhite, IconYoutube } from '../../Icons'
import styles from './Index.module.css';
import {
    LINKS_INSTAGRAM,
    LINKS_LINKEDIN,
    LINKS_NAV_APOIO_E_PATROCINEO,
    LINKS_NAV_PARA_CLIENTES,
    LINKS_NAV_PARA_MERCADOS,
    LINKS_TERMOS,
    LINKS_WHATSAPP,
    LINKS_YOUTUBE
} from '../../../Links';
import { useEffect, useState } from 'react';

export const FooterSiteV1Style = {
    style_1: 'style_1',
    style_2: 'style_2',
}
export const FooterSiteV1 = ({ _FooterSiteV1Style }) => {
    const [state, setState] = useState(false)
    const [currentYear, setCurrentYear] = useState(null)
    useEffect(() => {
        if (!state) {
            setState(true);
            return;
        }
        setCurrentYear(Math.max(new Date().getFullYear(), 2026));// pelo menos 2026 para cima
    }, [state])


    let addStyle = null;
    switch (_FooterSiteV1Style) {
        case FooterSiteV1Style.style_1:
            addStyle = styles.footer_style_1;
            break;

        default:
            addStyle = styles.footer_style_2;
            break;
    }
    return <>
        <footer className={`${styles.footer} ${addStyle}`}>
            <div className={styles.footer_top}>
                <div className={styles.footer_logo_text}>
                    <IconTooMeWhite className={styles.footer_logo} />
                    <div className={styles.footer_links_group}>
                        <div className={styles.footer_links_column}>
                            <p>TooMe</p>
                            <Link to={LINKS_NAV_PARA_CLIENTES()} className={styles.footer_link}>Sobre Nós</Link>
                            <Link to={LINKS_TERMOS} className={styles.footer_link}>Termos e Privacidade</Link>
                        </div>
                        <div className={styles.footer_links_column}>
                            <p>Parceiros</p>
                            <Link to={LINKS_NAV_PARA_MERCADOS()} className={styles.footer_link}>Para Mercados</Link>
                            <Link to={LINKS_NAV_APOIO_E_PATROCINEO()} className={styles.footer_link}>Patrocine o TooMe</Link>
                        </div>

                    </div>
                </div>

                <div className={styles.footer_social_icons}>
                    <a
                        href={LINKS_INSTAGRAM}
                        className={styles.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    />
                    <a
                        href={LINKS_LINKEDIN}
                        className={styles.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                    />
                    <a
                        href={LINKS_WHATSAPP}
                        className={styles.whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="WhatsApp"
                    />
                    <a
                        href={LINKS_YOUTUBE}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Youtube"

                    ><IconYoutube color='var(--cor_tooMe)' size='35' /></a>
                </div>
            </div>

            <div className={styles.footer_bottom}>
                <p>&copy; {currentYear} TooMe. Todos os direitos reservados.</p>
            </div>
        </footer>
    </>
}